import '@zr/common/js/jquery-plugins/jquery.floatLabels';
import '@zr/common/js/jquery-plugins/jquery.validate.min';
import '@zr/common/js/jquery-plugins/jquery.validate-additional-methods.min';
import '@zr/common/js/jquery-plugins/zr-validate-additional-methods';
import loadMailcheck from '@zr/common/js/loadMailcheck';

const $loginForm = $('#login_form');

$loginForm.floatLabels();

loadMailcheck({
  emailSuggestionTemplateVariable: '[%address%]', // go-18n seems to panic when we use {{address}} in translations. Maybe there's a way around that.
  emailSuggestionTemplate: zr.page.translations.LOGIN_DID_YOU_MEAN_ADDRESS_TEMPLATE,
  emailSuggestionYes: zr.page.translations.YES,
  emailSuggestionNo: zr.page.translations.NO,
});

// recaptcha script is loaded on login.pongo
let recaptchaWidgetId;

function reCaptchaLoadCallback() {
  function finishFormSubmit() {
    const [form] = $loginForm;
    form.submit();
  }

  $.log_event('google_recaptcha_loaded');

  // render reCAPTCHA
  recaptchaWidgetId = window.grecaptcha.render('recaptcha_login', {
    sitekey: $('#recaptchaScript').data('sitekey'),
    badge: 'bottomright',
    size: 'invisible',
    callback: finishFormSubmit,

    /**
     * We're not currently providing the language code to reCAPTCHA
     * and allowing it to determine the correct language on its own.
     */
    // hl: 'iw',
  });
}

window.reCaptchaLoadCallback = reCaptchaLoadCallback;
// validate contact form on keyup and submit
$loginForm.validate({
  rules: {
    email: {
      required: {
        depends() {
          const $e = $(this);
          const val = $e.val();
          if (val.match(/^\s+|\s+$/)) {
            $e.val($.trim(val));
          }
          return true;
        },
      },
      email: true,
    },
    password: {
      required: true,
    },
  },
  messages: {
    email: zr.page.translations.LOGIN_PLEASE_ENTER_A_VALID_EMAIL_ADDRESS,
    password: zr.page.translations.LOGIN_PLEASE_ENTER_A_PASSWORD,
  },

  // connect form to reCAPTCHA and enable submit button
  submitHandler() {
    if (window.grecaptcha) {
      window.grecaptcha.execute(recaptchaWidgetId);
    } else {
      const [form] = $loginForm;
      form.submit();
    }
    return false;
  },
});

// log event when clicking on the submit button:
$loginForm.on('click', '#submit_button', () => {
  const withEmail = $('#email').val() === '' ? 0 : 1;
  const withPassword = $('#password').val() === '' ? 0 : 1;
  $.log_event('button_click', { button_name: 'sign_in', with_email: withEmail, with_password: withPassword });
});
